<template>
    <div id="vipPanel" class="cover vip_cover">
        <div class="cover_center_panel vip_cover_panel">
            <div class="tab_nav">
                <div :class="['tab_item',{'active':openTypes==1}]" @click="changePayType(1)">Chat3.5会员</div>
                <div :class="['tab_item',{'active':openTypes==2}]" @click="changePayType(2)">Chat4.0字数包</div>
                <div :class="['tab_item',{'active':openTypes==3}]" @click="changePayType(3)">高清MJ绘图<span class="tab_tag">送3.5会员</span></div>
                <div class="tab_item close_btn" @click="closePanel">关闭</div>
            </div>
            <div class="panel_content">
                <div class="content_header">
                    <img class="avatar" :src="userInfo.avatarurl || df_avatar" >
                    <div class="user_info" v-if="openTypes==3">
                        <div class="user_name">{{ userInfo.nickname ? userInfo.nickname : "微信用户" }}<span :class="['vip_icon',userInfo.draw_is_vip?'is_vip':'no_vip']"></span></div>
                        <div class="user_desc">ID：{{userInfo.uid}}<span class="vip_end_time" v-if="userInfo.draw_is_vip==1"> 会员{{ userInfo.draw_vip_end_date }}</span></div>
                    </div>
                    <div class="user_info" v-else>
                        <div class="user_name">{{ userInfo.nickname ? userInfo.nickname : "微信用户" }}<span :class="['vip_icon',userInfo.is_vip?'is_vip':'no_vip']"></span></div>
                        <div class="user_desc">ID：{{userInfo.uid}}<span class="vip_end_time" v-if="userInfo.is_vip==1"> 会员{{ userInfo.vip_end_date }}</span></div>
                    </div>
                    <div class="vip_slogin" v-if="openTypes==1">开通付费会员·畅享无限制聊天次数·速度更快</div>
                    <div class="vip_slogin" v-if="openTypes==2">为回馈新老会员·字数收费价格暂定和官方一样</div>
                    <div class="vip_slogin" v-if="openTypes==3">对接官方MJ绘画接口·价格更便宜·出图更稳定</div>
                </div>
                <ul class="set_meal_list" v-if="openTypes == 1">
                    <li :class="['set_meal_item',{'active':selectedVip.id==vip.id}]" v-for="vip in payTypes" @click="chooseSetMeal(vip)">
                        <div :class="['top_tps',{'active':selectedVip.id==vip.id}]" v-if="vip.top_tip">{{ vip.top_tip }}</div>
                        <div class="set_meal_name"><span class="set_meal_moeny">¥ {{ vip.show_money}}</span>/ {{ vip.pro_name }}</div>
                        <div class="set_meal_desc">每天仅{{ vip.day_money }}元 次数不限</div>
                        <div class="set_meal_desc">{{ vip.top_tip2 }}</div>
                        <div class="set_meal_desc">{{ vip.top_tip4 }}</div>
                        <div class="set_meal_desc">{{ vip.top_tip3 }}</div>
                        <img v-show="selectedVip.id==vip.id" class="active_icon" src="./img/selected_icon.png">
                    </li>
                </ul>
                <ul class="set_meal_list" v-if="openTypes == 2">
                    <li :class="['set_meal_item',{'active':selectedVip.id==vip.id}]" v-for="vip in payTypes" @click="chooseSetMeal(vip)">
                        <div :class="['top_tps',{'active':selectedVip.id==vip.id}]" v-if="vip.top_tip">{{ vip.top_tip }}</div>
                        <div class="set_meal_name"><span class="set_meal_moeny">¥ {{ vip.show_money}}</span>/ {{ vip.pro_name }}</div>
                        <div class="set_meal_desc">{{ vip.top_tip2 }}</div>
                        <div class="set_meal_desc">{{ vip.top_tip3 }}</div>
                        <div class="set_meal_desc">{{ vip.top_tip4 }}</div>
                        <div class="set_meal_desc">{{ vip.top_tip5 }}</div>
                        <img v-show="selectedVip.id==vip.id" class="active_icon" src="./img/selected_icon.png">
                    </li>
                </ul>
                <ul class="set_meal_list" v-if="openTypes == 3">
                    <li :class="['set_meal_item',{'active':selectedVip.id==vip.id}]" v-for="vip in payTypes" @click="chooseSetMeal(vip)">
                        <div :class="['top_tps',{'active':selectedVip.id==vip.id}]" v-if="vip.top_tip">{{ vip.top_tip }}</div>
                        <div class="set_meal_name"><span class="set_meal_moeny">¥ {{ vip.show_money}}</span>/ {{ vip.pro_name }}</div>
                        <div class="set_meal_desc">{{ vip.top_tip2 }}</div>
                        <div class="set_meal_desc">{{ vip.top_tip3 }}</div>
                        <div class="set_meal_desc">{{ vip.top_tip4 }}</div>
                        <div class="set_meal_desc">{{ vip.top_tip5 }}</div>
                        <img v-show="selectedVip.id==vip.id" class="active_icon" src="./img/selected_icon.png">
                    </li>
                </ul>
                <div class="content_bottom">
                    <div class="bottom_left">
                        <ul class="advantage" v-if="openTypes==1">
                            <li v-for="(ad,index) in advantages" :key="index">{{ ad }}</li>
                        </ul>
                        <div class="gpt_price" v-if="openTypes == 2">
                            <div class="price_title">官方Chat4.0收费价格</div>
                            <div class="price_item">提问：0.03美元/1000tokens</div>
                            <div class="price_item">回答：0.06美元/1000tokens</div>
                            <div class="price_item">2tokens≈1汉字 1tokens≈1个英文单词</div>
                        </div>
                        <ul class="advantage" v-if="openTypes==3">
                            <li>更为先进的AI绘画算法</li>
                            <li>会员期间，不限制绘画次数</li>
                            <li>更快的响应速度，出图更稳定</li>
                        </ul>
                        <div class="agreement"><input type="checkbox" v-model="agreement" class="pointer"> 开通会员代表您接受 <a target="_blank" href="http://help.xiutanshu.com/help/agree.html">《订阅会员协议》</a></div>
                    </div>
                    <template v-show="agreement">
                        <div class="pay_code">
                            <img class="timeout" v-if="left_time==0" src="./img/qrcode.jpg" alt="" srcset="">
                            <canvas class="timeout" v-else id="canvas"></canvas>
                        </div>
                        <div class="pay_info">
                            <div class="line_one">应付金额：<span class="pay_money"><span class="money_count">￥{{ selectedVip.show_money }}</span><span v-if="coupon_id>0">已优惠：{{coupon_money}}元</span></span></div>
                            <div class="line_two"><img src="./img/wx_pay.png" alt=""><img src="./img/ali_pay.png" alt="">请使用微信/<span class="zfb">支付宝</span>扫码支付</span></div>
                            <div class="pay_tips"><span v-if="coupon_id">送您的{{coupon_money}}元优惠券</span>将在 <span class="left_time">{{ left_time_text }}</span> 秒后过期，请尽快完成支付</div>
                        </div>
                    </template>
                </div>
                <div class="gpt4_tips" v-if="openTypes==1">温馨提示：请试用满意后再付款，虚拟产品，暂不支持退款，感谢理解！如果有绘画需求，建议购买绘画会员，免费送Chat3.5会员时长，更划算！</div>
                <div class="gpt4_tips" v-if="openTypes==2">温馨提示：请试用满意后再付款，虚拟产品，暂不支持退款，感谢理解！对接Chat4.0版官方接口，暂不加利润！扣费标准一律同步官方字数包价格！</div>
                <div class="gpt4_tips" v-if="openTypes==3">温馨提示：请试用满意后再付款，虚拟产品，暂不支持退款，感谢理解！提示词越长，出图时间越长。独家技术研发，对接MJ绘画官方API接口！</div>

            </div>
        </div>
        <couponPopup v-if="couponVisible" :showPopup.sync="couponVisible" :couponMoney="coupon_money" @receiveHandle="receiveCoupon" ></couponPopup>
        <newuserCoupon v-if="newCouponVisible" :showPopup.sync="newCouponVisible" @receiveHandle="receiveCoupon" ></newuserCoupon>
    </div>
</template>
<script type="text/ecmascript-6">
    import couponPopup from "./couponPanel.vue"
    import newuserCoupon from "./NewUserCoupon.vue"
    import QRCode from 'qrcode'
    export default {
        components:{couponPopup, newuserCoupon},
        props:['showPopup','from',"type"],
        data() {
            return {
                openTypes:1,
                payTypes:[],
                selectedVip:{},
                advantages:["可使用最新版的Chat4.0功能","会员期间，限制提问次数","更快的响应速度，回答的更智能"],
                agreement:true,
                left_time:600,
                left_time_text:"10:00",
                df_avatar:require("../views/img/df_avatar.png"),
                timer:null,
                timeout:false,
                couponVisible:false,
                coupon_money:0,
                coupon_id:0,
                uniq_key:"",
                showFrist:false,
                newCouponVisible:false
            }
        },
        created() {
            if(this.type) this.openTypes = this.type
            this.fetchGoodsList()
        },
		computed:{
            userInfo(){
                return this.$store.state.userInfo;
            }
		},
        mounted(){
        },
        methods: {
            changePayType(openType){
                // 切换
                if(openType == 2 && this.userInfo.is_vip==0){
                    this.$toast("4.0字数包仅支持会员购买");
                    return;
                }
                this.openTypes = openType;
                this.fetchGoodsList();

            },
            fetchGoodsList(){
                let ctype = SiteCtype
                if(this.openTypes == 2){
                    ctype = "word"
                }
                if(this.openTypes == 3){
                    ctype = "mjdraw"
                }
                this.$http.get('/pay/agentgoods/',{params:{ctype:ctype}}).then((res) => {
                    if(res.status == 200){
                        this.payTypes = res.data;
                        if(res.data.length) this.selectedVip = res.data[1];
                        this.getCoupon();
                        this.chooseSetMeal(this.selectedVip)
                    }
                })
            },
            fetchGoodsList1(){
                this.openTypes = 1;
                let ctype = SiteCtype
                this.$http.get('/pay/agentgoods/',{params:{ctype:ctype}}).then((res) => {
                    if(res.status == 200){
                        this.payTypes = res.data;
                        if(res.data.length) this.selectedVip = res.data[3];
                        this.chooseSetMeal(this.selectedVip)
                        this.getCouponFirst();
                    }
                })
            },
            setPayTime() {
                this.timer = setInterval(()=>{
                    this.left_time--;
                    let m = parseInt(this.left_time/60);
                    let s = this.left_time%60;
                    if(m < 10) m = "0"+m
                    if(s < 10) s = "0"+s
                    this.left_time_text = m +":"+s
                    if(this.left_time == 0){
                        // this.left_time = 600
                        clearTimeout(this.timer)
                    } 
                },1000)
            },
            getPayStatus(){
                this.payTimer = setInterval(() => {
                    this.$http.get("/pay/chongzhi/?uniq_key=" + this.uniq_key,{params:{ctype:SiteCtype}}).then((res) => {
                        if (res.data.code == 1) {
                            this.$toast("支付成功");
                            this.$emit('update:showPopup', false);
                            clearTimeout(this.payTimer);
                            this.$emit("confirm")
                        }
                    })
                }, 3000)
            },
            getCoupon(){
                if(this.openTypes==1){
                    this.$http.get('/front/my/coupon/gift/',{params:{ctype:SiteCtype}}).then((res) => {
                        if (res.status == 200) {
                            this.coupon_money = res.data.money
                            this.cur_coupon_id = res.data.coupon_id
                            if(res.data.is_vip_end==1&&this.coupon_money>0){
                                this.couponVisible = true;
                            }
                        }
                    })
                }
            },
            getCouponFirst(){
                if(this.openTypes==1){
                    this.selectedVip = this.payTypes[3]
                    this.$http.get('/front/my/coupon/gift/',{params:{ctype:'pcfirst'}}).then((res) => {
                        console.log(res)
                        if (res.status == 200) {
                            console.log("2000")
                            this.coupon_money = res.data.money
                            this.cur_coupon_id = res.data.coupon_id
                            if(res.data.is_vip_end==1&&this.coupon_money>0){
                                this.selectedVip.top_tip = "新人专享"
                                this.newCouponVisible = true;
                            }
                            if(this.cur_coupon_id==0){
                                this.$emit("update:showPopup",false);
                                this.$emit("confirm")
                                //埋点
                                let user_id = localStorage.getItem("user_id")||0;
                                zjzBrowseRecord({user_id:user_id, mod_code:"p007"})
                            }
                        }
                    })
                }
            },
            closePanel(){
                // if(this.openTypes==1){
                    if(this.userInfo.is_vip==1||this.userInfo.draw_is_vip==1){
                        this.$emit("update:showPopup",false);
                        this.$emit("confirm")
                        //埋点
                        let user_id = localStorage.getItem("user_id")||0;
                        zjzBrowseRecord({user_id:user_id, mod_code:"p007"})
                    }else{
                        console.log("closePanel", this.showFrist)
                        if(this.showFrist){
                            this.$emit("update:showPopup",false);
                            this.$emit("confirm")
                            //埋点
                            let user_id = localStorage.getItem("user_id")||0;
                            zjzBrowseRecord({user_id:user_id, mod_code:"p007"})
                        }else{
                            this.fetchGoodsList1()
                            this.showFrist = true
                            // this.getCouponFirst()
                        }
                    }
                // }else{
                //     this.$emit("update:showPopup",false);
                //     this.$emit("confirm")
                //     //埋点
                //     let user_id = localStorage.getItem("user_id")||0;
                //     zjzBrowseRecord({user_id:user_id, mod_code:"p007"})
                // }
            },
            chooseSetMeal(vip){
                this.left_time_text = "10:00"
                this.left_time = 600
                if(this.timer)
                    clearInterval(this.timer);
                if(this.payTimer)
                    clearTimeout(this.payTimer);

                this.selectedVip = vip;
                //如果支付二维码可以放在payTypes列表中，就不需要请求接口了
                let data = { "appid":APP_ID, "pro_id": vip.id, "pay_from": "h5pay", "pay_flat": 1, coupon_id: this.coupon_id }

                this.$http.post('/pay/chongzhi/?ctype=agent&scanpay=1', data).then((res) => {
                    if(res.status == 200){
                        this.code_url = res.data.pay_url;
                        this.uniq_key = res.data.uniq_key;
                        var canvas = document.getElementById('canvas')
                        QRCode.toCanvas(canvas, this.code_url, function (error) {
                            if (error) console.error(error)
                        })
                        this.setPayTime()
                        this.getPayStatus()
                    }
                })
            },
			receiveCoupon(){
                this.coupon_id = this.cur_coupon_id
				let item = this.payTypes.filter((pay)=>pay.id == this.coupon_id);
				item = item[0]
                this.chooseSetMeal(this.selectedVip)
				let step = parseInt(this.coupon_money / 20);
				let showMoeny = item.show_money - this.coupon_money;
                item.day_money = (showMoeny / 365).toFixed(2);
				let timer = setInterval(()=>{
					item.show_money -= step;
					if(item.show_money <= showMoeny){
						item.show_money = showMoeny;
						clearInterval(timer);
					}
				},50)
			},
        },
        beforeDestroy(){
            clearInterval(this.timer);
            clearTimeout(this.payTimer);
        }
    };
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
    .vip_cover{
        .vip_cover_panel{
            padding: 28px 25px;
            width: 980px;
            border-radius: 6px;
            .tab_nav{
                display: flex;
                justify-content: space-between;
                margin-bottom: 22px;
                .tab_item{
                    width: 232px;
                    height: 50px;
                    line-height: 46px;
                    text-align: center;
                    font-size: 18px;
                    color: #999;
                    border: 2px solid #999;
                    border-radius: 4px;
                    background-color: #f0f0f0;
                    cursor: pointer;
                    position: relative;
                    &.close_btn{
                        background-color: #ffffcc;
                        border-color: #ef5831;
                        color: #ef5831;
                        width: 82px;
                    }
                    &.active{
                        background-color: #ef5831;
                        color: #fff;
                        border-color: #ef5831;
                        &::after{
                            content: "";
                            display: block;
                            border: 22px solid transparent;
                            position: absolute;
                            border-top-color: #ef5831;
                            bottom: -44px;
                            left: 50%;
                            margin-left: -22px;
                        }
                    }
                    .tab_tag{
                        position: absolute;
                        display: block;
                        width: 60px;
                        height: 22px;
                        color: #fff;
                        font-size: 12px;
                        border-radius: 3px;
                        background-color: #ef5831;
                        line-height: 22px;
                        text-align: center;
                        top: -12px;
                        right: -18px;
                    }
                }
            }
            .panel_content{
                border: 2px solid #f4f4f4;
                border-radius: 2px;
                overflow: hidden;
                .content_header{
                    height: 60px;
                    display: flex;
                    align-items: center;
                    padding: 0 45px;
                    background-color: #f0f0f0;
                    .avatar{
                        width: 30px;
                        height: 30px;
                        background-size: 100% 100%;
                        flex-shrink: 0;
                        cursor: pointer;
                        border-radius: 50%;
                        margin-right: 12px;
                    }
                    .user_info{
                        flex-grow: 1;
                        overflow: hidden;
                        .user_name{
                            font-weight: bold;
                            font-size: 12px;
                            line-height: 20px;
                            .vip_icon{
                                display: inline-block;
                                width: 14px;
                                height: 14px;
                                background-size: 100% 100%;
                                vertical-align: middle;
                                margin-top: -2px;
                                margin-left: 8px;
                                &.is_vip{
                                    background-image: url("../views/img/is_vip.png");
                                }
                                &.no_vip{
                                    background-image: url("../views/img/no_vip.png");
                                }
                            }
                        }
                        .user_desc{
                            color: #999;
                            font-size: 11px;
                            line-height: 19px;
                        }
                    }
                    .vip_slogin{
                        white-space: nowrap;
                        height: 36px;
                        font-size: 14px;
                        color: #999;
                        line-height: 36px;
                        background-color: #fff;
                        padding: 0 18px;
                        border-radius: 4px;
                    }
                }
                .set_meal_list{
                    padding: 25px 24px 20px;
                    display: flex;
                    justify-content: space-between;
                    flex-wrap: wrap;
                    background-color: #f0f0f0;
                    .set_meal_item{
                        cursor: pointer;
                        width: 200px;
                        background: #fff;
                        border-radius: 2px;
                        border: 1px solid #e5e5e5;
                        padding: 16px 0 20px;
                        display: flex;
                        flex-direction: column;
                        align-items: center;
                        position: relative;
                        border-radius: 8px;
                        &.active{
                            border-color: #ef5831;
                        }
                        .top_tps{
                            position: absolute;
                            right: -1px;
                            top: -8px;
                            color: #fff;
                            font-weight: bold;
                            padding: 4px 8px;
                            background-color: #999;
                            border-radius: 8px 0 8px 0;
                            &.active{
                                background-color: #ef5831;
                            }
                        }
                        .set_meal_name{
                            font-size: 13px;
                            line-height: 33px;
                            margin-bottom: 10px;
                            .set_meal_moeny{
                                font-size: 26px;
                                color: #ef5831;
                                margin-right: 10px;
                            }
                        }
                        .set_meal_desc{
                            font-size: 12px;
                            color: #999;
                            line-height: 24px;
                        }
                        .active_icon{
                            position: absolute;
                            display: block;
                            bottom: -1px;
                            right: -1px;
                            width: 38px;
                        }
                    }
                }
                .content_bottom{
                    display: flex;
                    align-items: center;
                    border-top: 1px dashed #e6e6e6;
                    height: 220px;
                    padding: 0 24px;
                    margin: 0 20px;
                    .bottom_left{
                        padding-right: 32px;
                        white-space: nowrap;
                        .advantage{
                            font-size: 15px;
                            li{
                                position: relative;
                                line-height: 44px;
                                padding-left: 8px;
                                &::before{
                                    content: "";
                                    display: block;
                                    width: 2px;
                                    height: 2px;
                                    background: #333;
                                    position: absolute;
                                    top: 50%;
                                    left: 0;
                                    margin-top: -1px;
                                }
                            }
                        }
                        .gpt_price{
                            font-size: 12px;
                            .price_title{
                                font-weight: bold;
                                line-height: 1;
                                margin-bottom: 11px;
                            }
                            .price_item{
                                color: #666;
                                line-height: 34px;
                            }
                        }
                        .agreement{
                            font-size: 13px;
                            color: #999;
                            line-height: 1;
                            margin-top: 18px;
                            .pointer{
                                vertical-align: middle;
                                margin-top: -3px;
                            }
                            a{
                                color: #fd6a41;
                                text-decoration: underline;
                            }
                        }
                    }
                    .pay_code{
                        border: 2px solid #e9e9e9;
                        border-radius: 3px;
                        margin-right: 32px;
                        flex-shrink: 0;
                        .timeout{
                            width: 153px!important;
                            height: 153px!important;
                            display: block;
                        }
                    }
                    .pay_info{
                        color: #999;
                        font-size: 15px;
                        flex-grow: 1;
                        .line_one{
                            margin-bottom: 29px;
                            line-height: 29px;
                            .pay_money{
                                color: #ef5831;
                                .money_count{
                                    font-size: 27px;
                                    padding: 0 13px 0 6px;
                                }
                            }
                        }
                        .line_two{
                            font-size: 14px;
                            color: #3baf36;
                            line-height: 22px;
                            margin-bottom: 22px;
                            img{
                                vertical-align: middle;
                                margin: 0 5px;
                                width: 22px;
                            }
                        }
                        .pay_tips{
                            line-height: 25px;
                            .left_time{
                                color: #fa4632;
                            }
                        }
                    }
                }
                .gpt4_tips{
                    height: 32px;
                    line-height: 32px;
                    text-align: center;
                    margin: 0 10px 8px;
                    background-color: #ffffcc;
                    font-size: 13px;
                    color: #ef5833;
                }
            }
        }
    }
</style>